import frasesFin from './assets/frasesFin.json';

export default  function ObtFraseFin(porcentaje:number){
  var num=Number(porcentaje);
  var indice=0;
  if(num>=95){
    indice=0;
  }else if(num>=90){
    indice=1;
  }else if(num>=70){
    indice=2;
  }else if(num>=50){
    indice=3;
  }else if(num>=25){
    indice=4;
  }else{
    indice=5;
  }


  return frasesFin[indice].frases[Math.floor(Math.random()* frasesFin[5].frases.length)];
}